import React from 'react'
import PropTypes from 'prop-types'

import CardInfoSkeleton from './CardInfoSkeleton'

const CardInfo = ({ title, subtitle, description, label }) => {
  return (
    <CardInfoSkeleton
      titleSection={title}
      subtitleSection={subtitle}
      descriptionSection={description}
      labelSection={label}
    />
  )
}

CardInfo.propTypes = {
  title: PropTypes.any,
  subtitle: PropTypes.any,
  description: PropTypes.string,
  label: PropTypes.any,
}

export default CardInfo
